import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { CustomField } from 'core/service/custom-fields/custom-field.type';
import FeatureFlagGuard from 'core/auth/feature-flag-guard.component';
import React from 'react';
import { CustomFieldStyled } from './custom-field.style';
import { DEVICE_MANAGEMENT_FEATURE_FLAG } from 'core/service/feature-flag/feature-flag.constants';

interface CustomFieldComponentProps {
    customField: CustomField;
    onClickOptions: (customField: CustomField) => void;
}

export const CustomFieldComponent: React.FC<CustomFieldComponentProps> = (props) => {
    const { customField, onClickOptions } = props;

    return (
        <CustomFieldStyled onClick={() => onClickOptions(customField)} data-testid={`custom-field-list-item`}>
            <div>
                <PocTypography variant="subtitle1" element="h6">
                    {customField.name}
                </PocTypography>
                <FeatureFlagGuard featureFlag={DEVICE_MANAGEMENT_FEATURE_FLAG}>
                    <PocTypography variant="caption" element="span">
                        {customField.type}
                    </PocTypography>
                </FeatureFlagGuard>
            </div>
            <PocIcon name="chevron_right" />
        </CustomFieldStyled>
    );
};
